<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="quoteMaterialId"
                 :primary-key="form.quoteMaterialId"
                 :foreign-key-column="foreignKeyColumn"
                 :foreign-key="foreignKey"
                 sortable
                 enable-change-order-up-down
                 disable-footer-length
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.quoteMaterialId" hidden/>

      <b-col cols="12" class="mb-2">

        <b-row>

          <b-col xl="12">

            <b-row>

              <b-col cols="6">

                <t-input-code-label :status="status" :add-error="error.typeBuildingMaterialId" ref="firstInput"
                                    type-building-material
                                    @onResume="setUnitPriceDefault"
                                    @focusout="focusByRef('input_quantity')" :command="command"
                                    v-model="form.typeBuildingMaterialId" required/>
              </b-col>



              <t-input cols="2" v-model="form.quantity" number ref="input_quantity"
                       label="Qtd." required/>

              <t-input v-model="form.unit" cols="2" select-common :options="UnitType.list" label="Un. Medida" required/>

              <t-input cols="2" v-model="form.unitPrice" submitted number :decimals="2"
                       label="Valor Un."/>

              <t-input cols="6" textarea v-model="form.note"
                       label="Obs." max-length="2000"/>

              <b-col xl="3" class="button-form-inline">

                <t-button :sending="status === 'sending'" tabindex="3" :text="onButtonSubmitText(command)" no-icon
                          submit/>

                <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                  {{ t('go-back') }}
                </b-link>

              </b-col>


            </b-row>


            <!--            <t-input cols="3" v-model="form.note" label="Observação"/>-->

          </b-col>


        </b-row>

      </b-col>

      <template #item(typeBuildingMaterial)="{item}">
        <span>{{ item.typeBuildingMaterial }} </span>
        <small v-if="item.note !== ''"><br/>{{ item.note }}</small>
      </template>

      <template #item(quantity)="{item}">
        <span>{{ item.quantity }} {{item.unit}} </span>
      </template>




    </t-form-list>

  </div>

</template>

<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import UnitType from "@/model/types/modules/general/UnitType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'QuoteMaterial',
  data() {
    return {
      UnitType,
      path: "business/quote-material", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "quoteId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "quoteMaterialId", keyDelete: "quoteMaterialId"},
        {key: "typeBuildingMaterial", label: "Material", cols: "3"},
        {key: "unitPrice", label: "Valor Un.", cols: "3", formatter: "money"},
        {key: "quantity", label: "Qtd.", cols: "2", formatter: "number"},
        {key: "totalPriceSale", label: "Valor Total", cols: "3", formatter: "money"},
      ],
      form: {
        quoteId: this.foreignKey,
        quoteMaterialId: 0,
        typeBuildingMaterialId: 0,
        quantity: 1,
        unit: "m",
        unitPrice: 0,
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        typeBuildingMaterialId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    customerId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {


    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      this.form.quantity = 1
      this.form.unit = "m"

      //this.focusByRef('firstInput')

    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.quoteMaterialId)


    },

    mountedList() {

      //this.focusByRef('firstInput')

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    setUnitPriceDefault(value) {
      console.log(value)
    }
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
